import { Item } from "../interfaces/Shop";

export const cpuList: Item[] = [
  { category: "CPU", name: "AMD Ryzen 5 2600", price: 117 },
  { category: "CPU", name: "Intel Core i5-9600K", price: 229 },
  { category: "CPU", name: "AMD RYZEN 5 3600", price: 194 }
];

export const motherBoardList: Item[] = [
  { category: "Motherboard", name: "MSI PRO Z390-A", price: 129 },
  { category: "Motherboard", name: "ASUS PRIME B360M-A", price: 84 },
  { category: "Motherboard", name: "ASRock B450M PRO4 AM4", price: 79 }
];

export const videoCardList: Item[] = [
  { category: "Video Card", name: "ZOTAC GeForce GTX 1060", price: 209 },
  { category: "Video Card", name: "MSI Radeon RX 580", price: 189 },
  { category: "Video Card", name: "GIGABYTE GeForce RTX 2070", price: 499 }
];

export const memoryList: Item[] = [
  { category: "Memory", name: "CORSAIR Vengeance RGB Pro 16GB", price: 97 },
  { category: "Memory", name: "G.SKILL TridentZ RGB Series 16GB", price: 86 },
  { category: "Memory", name: "G.SKILL Ripjaws Series 8GB", price: 42 }
];
